import React, { Component } from "react";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import cs from "classnames";

import mapDispatch from "~/misc/mapDispatch";
import { getUrlQeury } from "~/misc/formatUrlquery";
import { track } from "~/misc/metrics";
import PaymentOptions from "~/pages/Payment/components/PaymentOptions";
import Spinner from "~/components/common/Spinner";
import { getPaymentInfosAction } from "~/modules/hp/actions";
import vipShownameTransfer from "~/components/pages/vipShownameTransfer.js";
import { regEmail, regPhone, regPassWord, regDot, regMc } from "~/misc/reg";
import Stripe from "~/components/pages/Stripe";
import LoadingSpiner from "~/components/pages/MyAccount/share/LoadingSpiner";
import EndingPage from "~/components/pages/EndingPage";
import {getLastBillingInfoAction} from './apis/billing'
import {
  saveAccountAction,
  billInfoAction,
  getPaymentInfoAction,
  payOrderAction,
} from "./apis/payment";

import { BillDiscountText, BillPlanText } from "./utils";

import css from "./style.css";
import Input from "~/components/pages/MyAccount/share/Input";



const text = {
  empty: "This field is required!",
  dot: {
    wrong: "Not a valid DOT!",
    invaild: "Not a valid DOT!",
  },
  termOfService: {
    empty: "Please read and accept our terms.",
  },
  stripeTerm: {
    empty: "Please read and accept our terms.",
  },
  email: {
    wrong: "Enter a valid email!",
  },
  phone: {
    wrong: "Enter a valid phone number!",
  },
  firstName: {
    wrong: "20 char limit",
  },
  lastName: {
    wrong: "20 char limit",
  },
};

const CheckBox = ({ checked, onClick, children, error }) => {
  return (
    <div>
      <div onClick={onClick} className={css.checkBoxWarp}>
        <div
          className={cs(css.cleckBoxBox, {
            [css.cleckBoxActive]: checked,
          })}
        ></div>
        <div className={css.cleckBoxContent}>{children}</div>
      </div>
      {error && <div className={css.error}>{error}</div>}
    </div>
  );
};

const OrderForm = ({ handleChange, handleBlur, form, error }) => {
  return (
    <form className={css.orderForm}>
      <Input
        label={"firstName"}
        type="text"
        title={"First Name"}
        defaultValue={form.firstName}
        fnChange={(e) => handleChange("firstName", e.target.value)}
        fnBlur={(e) => handleBlur("firstName", e.target.value)}
        error={error.firstName ? error.firstName : ""}
      />
      <Input
        label={"lastName"}
        type="text"
        title={"Last Name"}
        defaultValue={form.lastName}
        fnChange={(e) => handleChange("lastName", e.target.value)}
        fnBlur={(e) => handleBlur("lastName", e.target.value)}
        error={error.lastName ? error.lastName : ""}
      />
      <Input
        label={"email"}
        type="text"
        title={"Email"}
        defaultValue={form.email}
        fnChange={(e) => handleChange("email", e.target.value)}
        fnBlur={(e) => handleBlur("email", e.target.value)}
        error={error.email ? error.email : ""}
      />
      <Input
        label={"address"}
        type="text"
        title={"Billing Address"}
        defaultValue={form.address}
        fnChange={(e) => handleChange("address", e.target.value)}
        fnBlur={(e) => handleBlur("address", e.target.value)}
        error={error.address ? error.address : ""}
      />
    </form>
  );
};

const membershipLevel = {
  essential: 2,
  preferred: 3,
  ultimate: 4,
};

class SimplePayment extends Component {
  constructor(props) {
    super(props);
    const { user } = props;
    this.state = {
      stage: 1,
      stageText: ["Activate Membership", "Done!"],
      selectedBill: {},
      bills: [],
      loading: true,
      form: {
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        email: user.email || "",
        address: "",
        trems: false,
      },
      error: {
        firstName: "",
        lastName: "",
        email: "",
        address: "",
        trems: "",
      },
      paymentCodes: false,
      submitLoading: false,
      orderStatus: "",
    };

    this.renderHeaderButton = this.renderHeaderButton.bind(this);
    this.renderBottomBtns = this.renderBottomBtns.bind(this);
  }
  componentWillMount() {
    // event tracking
    const query = getUrlQeury();
    if (!isEmpty(query) && query.from) {
      track("payment", { source: query.from });
    }
    this.setState({ level: query.level || "preferred" });
  }
  componentDidMount() {
    const { level } = this.state;
    const promisGetPaymentInfos = this.props.getPaymentInfos({
      platform: 'customer',
      gradeOptionKey: 'standard,premium,professional',
    });
    const promisUserBillingInfo = this.props.getLastBillingInfo();
    Promise.all([promisGetPaymentInfos,promisUserBillingInfo]).then(values => {
      const billingPackages = values[0];
      const accountLastBillingInfo = values[1];

      if (!billingPackages || !billingPackages.data) return;

      const { first_name, last_name, email, street_address,state,country,zip,seat_num, phone } = accountLastBillingInfo.data
      const formatBills = this.formatBills(billingPackages.data,{
        seat_num:seat_num && seat_num || 1
      });
      const defaultSelect =
        formatBills.find(
          (item) => item.grade === vipShownameTransfer[level].toLowerCase()
        ) || {};

      
      const formData = {
        firstName: first_name || '',
        lastName: last_name || '',
        email: email || "",
        address: street_address || '',
        // state:state || '',
        // country:country || '',
        // zip:zip || ''
      }

      this.setState({
        bills: formatBills,
        loading: false,
        selectedBill: defaultSelect.annually || {},
        form: formData,
        seat_num
      });
     
    });
   
    // this.props
    //   .getPaymentInfos({
    //     platform: "customer",
    //     gradeOptionKey: "standard,premium,professional",
    //   })
    //   .then((res) => {
    //     if (!res || !res.data) return;
    //     const formatBills = this.formatBills(res.data);
    //     const defaultSelect =
    //       formatBills.find(
    //         (item) => item.grade === vipShownameTransfer[level].toLowerCase()
    //       ) || {};
    //     this.setState({
    //       bills: formatBills,
    //       loading: false,
    //       selectedBill: defaultSelect.annually || {},
    //     });
    //   });
  }

  formatBills(bills,{seat_num}) {
    const { accountLevel } = this.props.account;
    // const accountLevel = 3;

    // only three packages
    const essential = {
      title: "Essential",
      grade: "essential",
      featuresText: "4 Features",
      salesPromotion: "",
    };
    const preferred = {
      title: "Preferred",
      grade: "preferred",
      featuresText: "7 Features",
      salesPromotion: "MOST POPULAR",
    };
    const ultimate = {
      title: "Ultimate",
      grade: "ultimate",
      featuresText: "13 Features",
      salesPromotion: "BEST VALUE",
    };
    for (let i = 0; i < bills.length; i++) {
      const element = bills[i];
      const key = bills[i]["key"] ? bills[i]["key"].split("_")[0] : "monthly";
      const grade = element.grade_name.toLowerCase();
      const temp = {
        shwoDiscountPrice: (element.discount_price * seat_num) / 100,
        showOriginPrice: element.origin_price / 100,
        dicountPrice: element.discount_price * seat_num,
        originPrice: element.origin_price,
        discountText: BillDiscountText[key],
        planText: BillPlanText[key],
        planId: `${grade}.${key}`,
        disable: accountLevel >= membershipLevel[grade],
        billCycle: element.bill_cycle,
        planKey: element.key,
        showName: element.show_name,
        showDescription: element.show_description,
      };
      if (grade === "essential") {
        essential[key] = temp;
      }
      if (grade === "preferred") {
        preferred[key] = temp;
      }
      if (grade === "ultimate") {
        ultimate[key] = temp;
      }
    }
    return [essential, preferred, ultimate];
  }
  selectStage(newStage, event) {
    if (event) {
      const query = getUrlQeury();
      if (!isEmpty(query) && query.from) {
        track(event, { source: query.from });
      }
    }
    this.setState({
      stage: newStage,
    });
  }
  selectBill(newBill) {
    this.setState({ selectedBill: newBill });
  }
  setFormValue = (key, value) => {
    const form = {
      ...this.state.form,
      [key]: value,
    };
    this.setState({
      form,
    });
  };
  setError = (key, value) => {
    this.setState(
      {
        error: {
          ...this.state.error,
          [key]: value,
        },
      },
      () => {
        console.log(this.state.error);
      }
    );
  };
  checkField = (key) => {
    const { form } = this.state;
    const value = form[key];
    switch (key) {
      case "email": {
        if (!regEmail.test(value)) {
          return text.email.wrong;
        }
        break;
      }
      case "firstName":
      case "lastName": {
        if (value.length > 20) {
          return text.firstName.wrong;
        }
        break;
      }
      default:
        break;
    }
  };
  checkFieldEmpty = (key) => {
    const { form } = this.state;
    if (form[key] == false) {
      return (text[key] && text[key].empty) || text.empty;
    }
  };
  checkSingleField = (key) => {
    let error = {
      ...this.state.error,
    };
    error[key] = this.checkFieldEmpty(key) || this.checkField(key);
    this.setState({
      error,
    });
  };
  checkAllField = () => {
    const { form } = this.state;
    let error = {};
    //special check
    Object.keys(form).map((key) => {
      error[key] = this.checkField(key);
    });
    // empty value check
    Object.keys(form).map((key) => {
      if (form[key] == false) {
        error[key] = this.checkFieldEmpty(key);
      }
    });
    this.setState({
      error,
    });
    return Object.values(error).some((e) => e);
  };

  handleChange = (key, value) => {
    this.setFormValue(key, value);
  };
  handleBlur = (key, value) => {
    this.checkSingleField(key);
  };

  handleSubmit = () => {
    if (this.state.submitLoading) return;
    const query = getUrlQeury();
    if (!isEmpty(query) && query.from) {
      track("pruchase_submit", { source: query.from });
    }
    const error = this.checkAllField();
    if (error) return;
    const { user, saveAccount, billInfo, getPaymentInfo } = this.props;
    const { selectedBill, form,seat_num } = this.state;
    this.setState({
      paymentError: "",
      submitLoading: true,
    });
    // To build order
    saveAccount({
      promotionCode: "vip",
      billCycle: selectedBill.billCycle,
      unitPrice: selectedBill.dicountPrice,
      currentCost: selectedBill.dicountPrice,
      billFirstname: form.firstName,
      billLastname: form.lastName,
      billEmail: form.email,
    }).then((res) => {
      if (!res) return;
      // To set order info
      billInfo({
        plan: 0,
        product: {
          seat_num: seat_num || 1,
          origin_price: selectedBill.originPrice,
          show_name: selectedBill.showName,
          discount_price: selectedBill.dicountPrice,
          pay_option: {
            key: selectedBill.planKey,
          },
          show_description: selectedBill.showDescription,
        },
        sc: "User",
        billing_info: {
          first_name: form.firstName,
          last_name: form.lastName,
          email: form.email,
          street_address: form.address,
          // phone: formData.phone,
          // dot: formData.dot,
        },
        tl_account_id: res.data.memberId,
      }).then((res) => {
        if (!res) return;
        this.setState({
          bussinessCode: res.data.business_code,
          orderId: res.data.order_id,
          paymentCodes: true,
        });
        // To get order info
        getPaymentInfo({
          id: user.id,
          bussinessCode: res.data.business_code,
          orderId: res.data.order_id,
          verifykey: res.data.verify_key,
        }).then((res) => {
          if (!res) return;
          // Finally ~~ Go to pay what a clever mind
          this.setState({
            submitLoading: false,
            totalAmount: res.data[0].total_amount,
          });
          document
            .querySelector(
              ".common-Button-button.pages-Stripe-wide.common-Button-action.common-Button-large"
            )
            .click();
        });
      });
    });
  };

  renderHeaderButton(curr) {
    const { stage, stageText } = this.state;

    return (
      <div
        className={cs(css.headerStageBtn, {
          [css.headerStageBtnSelected]: stage >= curr,
        })}
        onClick={() =>
          this.selectStage(curr, stage == 1 ? "activate_trail" : "done")
        }
      >
        <div className={css.stageLogo}>
          {stage >= curr ? (
            <img src="/assets/rightWhite.svg" />
          ) : (
            <span>{curr}</span>
          )}
        </div>
        <div className={css.stageText}>{stageText[curr - 1]}</div>
      </div>
    );
  }
  renderBottomBtns() {
    const {
      stage,
      bussinessCode,
      orderId,
      selectedBill,
      totalAmount,
      submitLoading,
      paymentCodes,
      form
    } = this.state;
    const { id } = this.props.user;
    const query = getUrlQeury();
    if (stage === 1)
      return (
        <div className={css.bottomBtns}>
          <div
            className={css.bottomeBtn}
            onClick={() => this.selectStage(2, "purchase_next")}
          >
            Next
          </div>
        </div>
      );
    if (stage === 2)
      return (
        <div className={css.bottomBtns}>
          <div
            className={cs(css.bottomeBtnBlock, css.bottomeBtn)}
            onClick={() => this.selectStage(1, "purchase_back")}
          >
            Back
          </div>
          <div className={css.bottomeBtn} onClick={() => this.handleSubmit()}>
            {submitLoading ? <LoadingSpiner /> : "Submit"}
          </div>
          <div style={{ display: "none" }}>
            {paymentCodes && totalAmount && (
              
              <Stripe
                from="a"
                amount={Number(totalAmount || selectedBill.dicountPrice)}
                query={{ bussinessCode, orderId }}
                email={form.email}
                actionFn={(dispatch, getState, val) => {
                  payOrderAction(dispatch, getState, {
                    id,
                    bussinessCode,
                    orderId,
                    token: val.token,
                    source:query && query.from
                  }).then((res) => {
                    const {code,data} = res;
                    if(code == 100){
                      const payInfo = {
                        error:res.message
                      }
                      this.setState({
                        orderStatus: "failure",
                        payInfo,
                      });
                    }else{
                      const payedInfo = data || {};
                    if (payedInfo.billing_info) {
                      const newBillInfo = {
                        ...payedInfo.billing_info,
                        // city: "",
                        // country: "",
                        // state: "",
                        // zip: "",
                      };
                      payedInfo.billing_info = newBillInfo;
                    }
                    
                    // if (!isEmpty(query)) {
                    //   const level = selectedBill.planKey.split('_')[1];
                    //   track('payment', {
                    //     'pay successful': 1,
                    //     source: query.from || 'Normal',
                    //     fromMembership: query.level,
                    //     membership: level,
                    //     biilling_cycle: selectedBill.billCycle,
                    //   });
                    // } 
                    this.setState({
                      orderStatus: "successful",
                      payedInfo,
                    });
                    }
                    
                  });
                }}
              />
            )}
          </div>
        </div>
      );
  }

  render() {
    const { stage, loading, form, error, orderStatus, payedInfo,payInfo } = this.state;
    const { user, account } = this.props;
    return (
      <section className={css.simplePayment}>
        {(orderStatus !== "successful" && orderStatus !== "failure") && (
          <header>
            <div>{this.renderHeaderButton(1)}</div>
            <div
              className={cs(css.headerEllipsis, {
                [css.headerStageBtnSelected]: stage > 1,
              })}
            >
              . . .
            </div>
            <div>{this.renderHeaderButton(2)}</div>
          </header>
        )}
        {(orderStatus !== "successful" && orderStatus !== "failure") && loading && (
          <div className={css.simplePaymentLoading}>
            <Spinner scalable={true} />
          </div>
        )}
        {(orderStatus !== "successful" && orderStatus !== "failure") && !loading && (
          <main>
            {stage === 1 && (
              <PaymentOptions
                bills={this.state.bills}
                default={this.state.selectedBill}
                changeSelected={(i) => this.selectBill(i)}
              />
            )}
            {stage === 2 && (
              <div className={css.formWarp}>
                <div className={css.fromTitle}>
                  Fill your Billing Information
                </div>
                <OrderForm
                  form={form}
                  error={error}
                  handleBlur={this.handleBlur}
                  handleChange={this.handleChange}
                ></OrderForm>

                <div className={css.formDesc}>
                  By submitting, you agree to our{" "}
                  <a
                    className={css.extLink}
                    href="https://truckerpath.com/privacy-policy"
                  >
                    Privacy Policy
                  </a>{" "}
                  and{" "}
                  <a
                    className={css.extLink}
                    href="https://truckerpath.com/terms-of-service"
                  >
                    Terms of Service
                  </a>
                </div>

                <CheckBox
                  checked={form.trems}
                  onClick={() => {
                    this.setState({
                      ...this.state,
                      form: {
                        ...form,
                        trems: !form.trems,
                      },
                    });
                  }}
                  error={error.trems}
                >
                  I have read and accepted the{" "}
                  <a
                    className={css.extLink}
                    href="https://stripe.com/payment-terms/legal"
                  >
                    Stripe Payment & Purchase Terms
                  </a>
                </CheckBox>
              </div>
            )}
            <footer>{this.renderBottomBtns()}</footer>
          </main>
        )}
        
        {(orderStatus  == 'successful' || orderStatus == 'failure') && (
          <div className={css.payResult}>
            <EndingPage
              user={user}
              account={account}
              orderInfo={payedInfo}
              payInfo={payInfo}
              type={orderStatus == 'successful' ? 'result' : 'pending'}
            />
          </div>
        )}
      </section>
    );
  }
}

export default connect(
  ({ user, account }) => ({ user, account }),
  mapDispatch({
    getPaymentInfos: (_, options) => getPaymentInfosAction(options),
    saveAccount: (_, params) => saveAccountAction(params),
    billInfo: (_, params) => billInfoAction(params),
    getPaymentInfo: (_, params) => getPaymentInfoAction(params),
    getLastBillingInfo: (_, params) => getLastBillingInfoAction(params),
  })
)(SimplePayment);


// WEBPACK FOOTER //
// ./src/pages/Payment/index.js